import { HttpClient } from 'shared/libs/http';
import { ApiResponseDto } from 'shared/types';
import { AddToFavoriteDto, FavFolder } from './types';

export class FavoritesApiService {
   public static getFavoritesFolderList() {
      return HttpClient.get<Array<FavFolder>>('/folder/list');
   }

   public static createFavoriteFolder(dto: { name: string }) {
      return HttpClient.post<ApiResponseDto<string>>('/folder/create', dto);
   }

   public static addToFavorite(
      dto: AddToFavoriteDto,
      opt: {
         candidateId: number;
         cvId: number;
      }
   ) {
      const localVarPath = `/candidates/addtoFavorite/${opt.candidateId}/${opt.cvId}`;
      return HttpClient.post<ApiResponseDto<string>>(localVarPath, dto);
   }
}
